export enum FeatureFlags {
  FACTOR_SOFT_CLIENT_AUTOMATION = 'ec68051c728aee7e9712f0866a0f312e2726363e093e5b60b02956d5f3ae508e',
  USE_UPDATED_SUPPORT_NUMBER = 'fe0aef84a5006df196d7a66b7d1feddbc2bca483010aeb37251494600ebb59bf',
  USE_NEW_REGISTRATION = 'dc787a56b2aa259940ef3e32738466933ecc449a21da992132d7f8af79ccae83',
  AUTH0_LOGIN = '43e3edab1c8c8e0366d34b17feeb203427cb10ae23e0a592b6be61d0b4aa8afd',
  PERMISSION_DELETE = '447f9c54a92c235ba7f7af26fa7389ad19cf82e6a3ccd98f94c0e79f7b1539c5',
}
